import React, { useState } from "react";
import MyMarqueeAdmin from "./MarqueeAdmin";
import DisplayCarousel from "./DisplayCarousel";
import ContactsList from "./ContactsList";
import VolunteerList from "./VolunteerList";
import DisplayImages from "./DisplayImages";
import DisplayApplications from "./DisplayApplications";
import DisplayCourseApplications from "./DisplayCourseApplications";
import AddSubscriber from "./AddSubscriber";
import DisplayReaders from "./DisplayReaders";

const PanelPage = () => {
  const [activeTab, setActiveTab] = useState("HERO");
  const [marqueeSettings, setMarqueeSettings] = useState({
    text: "Welcome to our website!",
    speed: "medium",
    direction: "left",
    bgColor: "#000000",
    textColor: "#ffffff",
    fontSize: "20",
    isEnabled: true,
  });

  const [heroSettings, setHeroSettings] = useState({
    title: "Hero Section Title",
    subtitle: "This is a hero section subtitle",
    buttonText: "Get Started",
    buttonColor: "#3B82F6",
    bgImage: "",
    overlay: true,
    alignment: "center",
  });

  const handleMarqueeChange = (field, value) => {
    setMarqueeSettings((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleHeroChange = (field, value) => {
    setHeroSettings((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSave = () => {
    // Handle save logic here
    console.log("Saving settings:", { marqueeSettings, heroSettings });
    alert("Settings saved successfully!");
  };

  const handleReset = () => {
    if (activeTab === "MARQUEE") {
      setMarqueeSettings({
        text: "Welcome to our website!",
        speed: "medium",
        direction: "left",
        bgColor: "#000000",
        textColor: "#ffffff",
        fontSize: "20",
        isEnabled: true,
      });
    } else {
      setHeroSettings({
        title: "Hero Section Title",
        subtitle: "This is a hero section subtitle",
        buttonText: "Get Started",
        buttonColor: "#3B82F6",
        bgImage: "",
        overlay: true,
        alignment: "center",
      });
    }
  };

  const handleLogout = () => {
    window.location.href = '/';
  };

  return (
    <div className="min-h-screen bg-base-200 p-6">
      {/* Header with Logout Button */}
      <div className="mb-8 bg-secondary p-6 rounded-lg shadow-md text-center relative">
        <button 
          className="btn btn-outline absolute top-4 right-4"
          onClick={handleLogout}
        >
          Logout
        </button>
        <h1 className="text-3xl font-bold text-base-content">
          Control Panel
        </h1>
        <p className="text-base-content/70">Manage your website components</p>
      </div>
      
      <div className="max-w-6xl mx-auto">
        {/* Main Content Card */}
        <div className="card bg-base-100 shadow-xl">
          <div className="card-body p-0">
            {/* Tabs Navigation */}
            <div className="tabs tabs-boxed bg-base-200 p-2">
              <button
                className={`tab tab-lg flex-1 ${
                  activeTab === "HERO" ? "tab-active" : ""
                }`}
                onClick={() => setActiveTab("HERO")}
              >
                <span className="font-semibold">🎯 HERO</span>
              </button>
              <button
                className={`tab tab-lg flex-1 ${
                  activeTab === "MARQUEE" ? "tab-active" : ""
                }`}
                onClick={() => setActiveTab("MARQUEE")}
              >
                <span className="font-semibold">📺 MARQUEE</span>
              </button>
              <button
                className={`tab tab-lg flex-1 ${
                  activeTab === "VOLUNTEERS" ? "tab-active" : ""
                }`}
                onClick={() => setActiveTab("VOLUNTEERS")}
              >
                <span className="font-semibold">👥 VOLUNTEERS</span>
              </button>
              <button
                className={`tab tab-lg flex-1 ${
                  activeTab === "CONTACTS" ? "tab-active" : ""
                }`}
                onClick={() => setActiveTab("CONTACTS")}
              >
                <span className="font-semibold">📞 CONTACTS</span>
              </button>
              <button
                className={`tab tab-lg flex-1 ${
                  activeTab === "IMAGE_GALLERY" ? "tab-active" : ""
                }`}
                onClick={() => setActiveTab("IMAGE_GALLERY")}
              >
                <span className="font-semibold">🖼️ IMAGE GALLERY</span>
              </button>
              <button
                className={`tab tab-lg flex-1 ${
                  activeTab === "APPLICATIONS" ? "tab-active" : ""
                }`}
                onClick={() => setActiveTab("APPLICATIONS")}
              >
                <span className="font-semibold">🎥 APPLICATIONS</span>
              </button>
              <button
                className={`tab tab-lg flex-1 ${
                  activeTab === "TRAINING APPLICATIONS" ? "tab-active" : ""
                }`}
                onClick={() => setActiveTab("TRAINING APPLICATIONS")}
              >
                <span className="font-semibold">⚙️ TRAINING APPLICATIONS</span>
              </button>
              <button
                className={`tab tab-lg flex-1 ${
                  activeTab === "ELIBRARY" ? "tab-active" : ""
                }`}
                onClick={() => setActiveTab("ELIBRARY")}
              >
                <span className="font-semibold">📚 ELIBRARY</span>
              </button>
              
            </div>

            {/* Tab Content */}
            <div className="p-6">
              {/* HERO Tab Content */}
              {activeTab === "HERO" && (
                <>
                  <DisplayCarousel />
                </>
              )}
              
              {/* MARQUEE Tab Content */}
              {activeTab === "MARQUEE" && <MyMarqueeAdmin />}
              
              {/* VOLUNTEERS Tab Content */}
              {activeTab === "VOLUNTEERS" && (
                <div>
                 <VolunteerList />
                </div>
              )}
              
              {/* CONTACTS Tab Content */}
              {activeTab === "CONTACTS" && (
                <div>
                 <ContactsList />
                </div>
              )}
              
              {/* IMAGE GALLERY Tab Content */}
              {activeTab === "IMAGE_GALLERY" && (
                <div>
                 <DisplayImages />
                </div>
              )}
              
              {/* APPLICATIONS Tab Content */}
              {activeTab === "APPLICATIONS" && (
                <div>
                  <DisplayApplications />
                </div>
              )}
              {/* TRAINING APPLICATIONS Tab Content */}
              {activeTab === "TRAINING APPLICATIONS" && (
                <div>     
              <DisplayCourseApplications />
            </div>
              )}
              {/* ELIBRARY Tab Content */}
              {activeTab === "ELIBRARY" && (
                <div>   
                  <AddSubscriber />
                  <DisplayReaders />
                </div>
              )}
            </div>


            {/* Action Buttons */}
            <div className="flex justify-end gap-3 p-6 bg-base-200 border-t">
              <button className="btn btn-ghost" onClick={handleReset}>
                Reset to Default
              </button>
              <button className="btn btn-primary" onClick={handleSave}>
                Save Changes
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PanelPage;